var layout2 = "col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6";
var layout3 = "col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4";
var layout4 = "col-6 col-sm-6 col-md-4 col-lg-3 col-xl-3";
var layout5 = "col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2";
var filters = document.getElementById('filterSideBar');
var filterContainer = document.getElementById('CollectionProductsContainer');
var upvFilterLifecycle = {
    activeRoot: null,
    resizeFrame: null,
    scrollFrame: null,
    filterDisplayTimer: null,
    windowEventsBound: false,
    filterSequence: 0,
    filterController: null,
    filterRequestRoot: null,
    loadMoreSequence: 0,
    loadMoreController: null,
    loadMoreRoot: null,
    loadMoreSentinel: null
};

function createFilterAbortController() {
    if (typeof AbortController == 'function') {
        try {
            return new AbortController();
        } catch (_error) {
            // Sequence checks below also protect environments with a broken polyfill.
        }
    }
    return {
        signal: undefined,
        abort: function() {}
    };
}

function abortFilterController(controller) {
    if (controller && typeof controller.abort == 'function') {
        try {
            controller.abort();
        } catch (_error) {
            // Sequence checks remain the source of truth when abort is unavailable.
        }
    }
}

function isFilterAbortError(error) {
    return Boolean(error && error.name == 'AbortError');
}

function cancelLoadMoreRequest() {
    upvFilterLifecycle.loadMoreSequence += 1;
    abortFilterController(upvFilterLifecycle.loadMoreController);
    var sentinel = upvFilterLifecycle.loadMoreSentinel;
    var loader = sentinel && sentinel.querySelector ? sentinel.querySelector('.load') : null;
    if (loader) loader.classList.add('hidden');
    upvFilterLifecycle.loadMoreController = null;
    upvFilterLifecycle.loadMoreRoot = null;
    upvFilterLifecycle.loadMoreSentinel = null;
}

function cancelFilterRequest() {
    upvFilterLifecycle.filterSequence += 1;
    abortFilterController(upvFilterLifecycle.filterController);
    var root = upvFilterLifecycle.filterRequestRoot;
    if (root && root.removeAttribute) root.removeAttribute('aria-busy');
    upvFilterLifecycle.filterController = null;
    upvFilterLifecycle.filterRequestRoot = null;
}

function cancelAllFilterWork() {
    cancelFilterRequest();
    cancelLoadMoreRequest();
}

function getFilterRoot() {
    return document.getElementById('CollectionProductsContainer');
}

function globoFilterIsRendered(root) {
    var body = document.body;
    var htmlHasState = document.documentElement.classList.contains('spf-status-loaded') ||
        document.documentElement.classList.contains('spf-has-filter');
    var bodyHasState = Boolean(body && (
        body.classList.contains('spf-status-loaded') ||
        body.classList.contains('spf-has-filter')
    ));
    var globoControls = document.querySelector('#gf-tree, #gf-grid, #gf-controls-container');
    var globoCards = root && root.querySelector ? root.querySelector('.spf-product-card') : null;
    return Boolean(htmlHasState || bodyHasState || globoControls || globoCards);
}

function nativeFilterOwnsRoot(root) {
    return Boolean(
        root &&
        root.getAttribute('data-upv-filter-owner') == 'native' &&
        document.documentElement.contains(root) &&
        !globoFilterIsRendered(root)
    );
}

function bindFilterEventOnce(element, key, eventName, handler) {
    if (!element) return false;
    var bindingId = key + ':' + eventName;
    var bindings = element.__upvFilterBindings || {};
    if (bindings[bindingId]) return false;
    bindings[bindingId] = true;
    element.__upvFilterBindings = bindings;
    element.addEventListener(eventName, handler);
    return true;
}

function runOptionalFilterHydrator(name) {
    if (typeof window[name] == 'function') {
        try {
            window[name]();
        } catch (_error) {
            // Optional product-card enhancements must not strand filter state.
        }
    }
}

function refreshFilterAOS() {
    if (
        typeof animationStatus != 'undefined' &&
        animationStatus &&
        typeof AOS != 'undefined' &&
        AOS &&
        typeof AOS.refreshHard == 'function'
    ) {
        try { AOS.refreshHard(); } catch (_error) {}
    }
}

function runFilterResizeWork() {
    upvFilterLifecycle.resizeFrame = null;
    var root = getFilterRoot();
    if (!nativeFilterOwnsRoot(root)) return;
    changeGridLayout();
    hideShowFilters();
    sortByVisibilityChange();
    var liveFilters = document.getElementById('filterSideBar');
    if (liveFilters && window.innerWidth < 768 && window.innerWidth > 760) {
        liveFilters.style.display = 'none';
        if (upvFilterLifecycle.filterDisplayTimer) {
            clearTimeout(upvFilterLifecycle.filterDisplayTimer);
        }
        upvFilterLifecycle.filterDisplayTimer = setTimeout(function() {
            upvFilterLifecycle.filterDisplayTimer = null;
            if (document.documentElement.contains(liveFilters)) {
                liveFilters.style.display = '';
            }
        }, 500);
    }
}

function scheduleFilterResizeWork() {
    if (upvFilterLifecycle.resizeFrame) return;
    var requestFrame = window.requestAnimationFrame || function(callback) {
        return setTimeout(callback, 16);
    };
    upvFilterLifecycle.resizeFrame = requestFrame(runFilterResizeWork);
}

function scheduleFilterScrollWork() {
    if (upvFilterLifecycle.scrollFrame) return;
    var requestFrame = window.requestAnimationFrame || function(callback) {
        return setTimeout(callback, 16);
    };
    upvFilterLifecycle.scrollFrame = requestFrame(function() {
        upvFilterLifecycle.scrollFrame = null;
        var root = getFilterRoot();
        if (nativeFilterOwnsRoot(root)) ScrollExecute();
    });
}

function bindNativeFilterWindowEvents() {
    if (upvFilterLifecycle.windowEventsBound) return;
    window.addEventListener('resize', scheduleFilterResizeWork, { passive: true });
    window.addEventListener('scroll', scheduleFilterScrollWork, { passive: true });
    upvFilterLifecycle.windowEventsBound = true;
}

function initializeNativeFilters() {
    var root = getFilterRoot();
    if (!nativeFilterOwnsRoot(root)) return false;
    upvFilterLifecycle.activeRoot = root;
    filters = document.getElementById('filterSideBar');
    filterContainer = root;
    root.removeAttribute('data-upv-filter-init-error');
    [
        bindNativeFilterWindowEvents,
        changeGridLayout,
        hideShowFilters,
        applyFilters,
        sortByOptions,
        showMoreFilters,
        hideFilters,
        sortBy
    ].forEach(function(initializer) {
        try {
            initializer();
        } catch (_error) {
            root.setAttribute('data-upv-filter-init-error', 'true');
        }
    });
    return true;
}

function changeGridLayout() {
    let parent = document.getElementById('CollectionProductsContainer');
    if (!nativeFilterOwnsRoot(parent)) return;
    let gridLayouts = document.querySelectorAll('.sort-grid-icon');
    Array.from(gridLayouts).forEach(function(layoutItem) {
        layoutItem.classList.remove('active');
    });

    var grid_layout_collection = typeof Cookies != 'undefined' && Cookies && typeof Cookies.get == 'function' ?
        Cookies.get('grid_layout_collection') : null;
    if (parent && gridLayouts.length > 0) {
        if (window.innerWidth < 768) {
            if (grid_layout_collection && grid_layout_collection != "grid-layout-4" && grid_layout_collection != "grid-layout-5") {
                var mobileLayout = document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]');
                if (mobileLayout) {
                    mobileLayout.classList.add('active');
                    parent.setAttribute("data-view", grid_layout_collection)
                }
            } else {
                var defaultMobileLayout = document.querySelector('.sort-grid-icon[data-value="grid-layout-2"]');
                if (defaultMobileLayout) {
                    defaultMobileLayout.classList.add('active');
                    parent.setAttribute("data-view", "grid-layout-2")
                }
            }
        } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
            if (grid_layout_collection && grid_layout_collection != "grid-layout-4" && grid_layout_collection != "grid-layout-5") {
                var tabletLayout = document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]');
                if (tabletLayout) {
                    tabletLayout.classList.add('active');
                    parent.setAttribute("data-view", grid_layout_collection)
                }
            } else {
                var defaultTabletLayout = document.querySelector('.sort-grid-icon[data-value="grid-layout-3"]');
                if (defaultTabletLayout) {
                    defaultTabletLayout.classList.add('active');
                    parent.setAttribute("data-view", "grid-layout-3")
                }
            }
        } else if (window.innerWidth >= 992) {
            if (grid_layout_collection) {
                var desktopLayout = document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]');
                if (desktopLayout) {
                    desktopLayout.classList.add('active');
                    parent.setAttribute("data-view", grid_layout_collection)
                }
            } else {
                var defaultDesktopLayout = document.querySelector('.sort-grid-icon[data-value="grid-layout-4"]');
                if (defaultDesktopLayout) {
                    defaultDesktopLayout.classList.add('active');
                    parent.setAttribute("data-view", "grid-layout-4")
                }
            }
        }
        updateGridView(parent);

    }
}

function hideShowFilters() {
    var root = getFilterRoot();
    if (!nativeFilterOwnsRoot(root)) return;
    var filterHeading = document.getElementById('filterHeading');
    filters = document.getElementById('filterSideBar');
    filterContainer = root;
    if (window.innerWidth < 768) {
        if (filterContainer && filterHeading) {
            if (filterHeading.classList.contains('filters-drawer-toggle')) {
                filterContainer.classList.add('filters-toggle');
            }
        }
    } else {
        if (filters) {
            filters.classList.remove('active')
            document.querySelector('body').classList.remove('open-filter-sort');
            document.querySelector('body').classList.remove('open-filter-popup');
        }
    }
    if (filterHeading) {
        bindFilterEventOnce(filterHeading, 'heading', 'click', (e) => {
                var liveRoot = getFilterRoot();
                if (!nativeFilterOwnsRoot(liveRoot)) return;
                e.preventDefault();
                var liveFilters = document.getElementById('filterSideBar');
                if (window.innerWidth > 767) {
                    if (liveRoot && filterHeading) {
                        if (filterHeading.classList.contains('filters-drawer-toggle')) {
                            DOMAnimations.classToggle(liveRoot, 'filters-toggle');
                        }
                    }
                } else if (liveFilters) {
                    liveFilters.classList.add('active')
                    document.querySelector('body').classList.add('open-filter-popup');
                    document.querySelector('body').classList.add('open-filter-sort');
                }
            });
    }
}
function hideFilters(){
  var cancelFiltes = document.getElementById('cancelFilters');
  if (cancelFiltes) {
    bindFilterEventOnce(cancelFiltes, 'cancel', 'click', (e) => {
      var root = getFilterRoot();
      if (!nativeFilterOwnsRoot(root)) return;
      e.preventDefault();
      var liveFilters = document.getElementById('filterSideBar');
      if (liveFilters) liveFilters.classList.remove('active')
      document.querySelector('body').classList.remove('open-filter-popup');
      document.querySelector('body').classList.remove('open-filter-sort');
    });
  }
}
window.addEventListener('load', initializeNativeFilters, { once: true });
document.addEventListener('shopify:section:load', function() {
    initializeNativeFilters();
});

function showMoreFilters() {
    const filterForm = document.getElementById('FiltersForm');
    if(filterForm && nativeFilterOwnsRoot(getFilterRoot())){
        var showMoreFilters = filterForm.querySelectorAll('.filters-expand');
        if (showMoreFilters) {
            Array.from(showMoreFilters).forEach(function(showMoreFilter) {
                bindFilterEventOnce(showMoreFilter, 'expand', 'click', (e) => {
                    if (!nativeFilterOwnsRoot(getFilterRoot())) return;
                    e.preventDefault();
                    if (showMoreFilter.classList.contains('active')) {
                        showMoreFilter.classList.remove('active');
                        DOMAnimations.slideUp(showMoreFilter.parentNode.querySelector('.more-options'), 150);
                        showMoreFilter.querySelector('span').textContent = showMoreText;
                    } else {
                        showMoreFilter.classList.add('active');
                        DOMAnimations.slideDown(showMoreFilter.parentNode.querySelector('.more-options'), 150);
                        showMoreFilter.querySelector('span').textContent = showLessText;
                    }
                });
            });
        }
    }
}

function applyFilters() {
    var section = document.getElementById('CollectionProductsContainer');
    if (nativeFilterOwnsRoot(section)) {
        var sectionParent = section.closest('.shopify-section');
        if (!sectionParent) return false;
        var sectionId = section.dataset.id;
        const filterForm = document.getElementById('FiltersForm');
        if (!filterForm) {
            return false;
        }
        //   showMultipleOptions(); 
        var layouts = sectionParent.querySelectorAll('.sort-grid-icon');
        Array.from(layouts).forEach(function(layout) {
            bindFilterEventOnce(layout, 'layout', 'click', (e) => {
                var liveSection = getFilterRoot();
                if (!nativeFilterOwnsRoot(liveSection)) return;
                e.preventDefault();
                if (!layout.classList.contains('active')) {
                    layout.classList.add('active');
                    let allGrids = liveSection.querySelectorAll('.aos-init');

                    Array.from(allGrids).forEach(function(grid) {
                        grid.classList.remove('aos-animate');
                        grid.classList.remove('aos-init');
                    });

                    setTimeout(function() {
                        if (!nativeFilterOwnsRoot(liveSection)) return;
                        Array.from(layouts).forEach(function(layoutItem) {
                            if (layoutItem != layout) {
                                layoutItem.classList.remove('active');
                            }
                        });
                        var _thisLayout = layout.dataset.value;
                        liveSection.setAttribute('data-view', _thisLayout)
                        updateGridView(liveSection);
                        var date = new Date();

                        date.setTime(date.getTime() + (parseInt(24 * 60 * 60 * 1000)));
                        if (typeof Cookies != 'undefined' && Cookies && typeof Cookies.set == 'function') {
                            Cookies.set('grid_layout_collection', _thisLayout, { expires: date, path: '/' });
                        }
                        let allImages = liveSection.querySelectorAll('.lazyloaded');

                        Array.from(allImages).forEach(function(image) {
                            image.classList.remove('lazyloaded');
                            image.classList.add('lazyload');
                        });
                    }, 800);
                }

            });
        });

        var priceRangeBars = filterForm.querySelectorAll('.mall-slider-handles');
        Array.from(priceRangeBars).forEach(function(rangeBar) {
            var el = rangeBar;
            var sliderEventListener = '';
            if (el.noUiSlider) {
                sliderEventListener = el.noUiSlider;
            } else {
                if (typeof window.noUiSlider == 'undefined' || typeof window.noUiSlider.create != 'function') {
                    return;
                }
                sliderEventListener = window.noUiSlider.create(el, {
                    step: 1,
                    connect: true,
                    start: [(parseFloat(el.dataset.start) || 0), parseFloat((el.dataset.end || el.dataset.max ))],
                    range: {
                        min: [parseFloat(el.dataset.min) || 0],
                        max: [parseFloat(el.dataset.max) || 100]
                    }
                });
            }
            if (!el.__upvFilterSliderBound) {
                el.__upvFilterSliderBound = true;
                sliderEventListener.on('change', function(values) {
                    var liveSection = getFilterRoot();
                    if (!nativeFilterOwnsRoot(liveSection) || window.innerWidth <= 767) return;
                    var minRange = $(this)[0].options.range.min;
                    var maxRange = $(this)[0].options.range.max;
                    var minVal = parseFloat(values[0]);
                    if (minVal >= minRange) {
                        var minimumInput = liveSection.querySelector('input[name="filter.v.price.gte"]');
                        if (minimumInput) minimumInput.value = minVal;
                    }
                    var maxVal = parseFloat(values[1]);
                    if (maxVal <= maxRange) {
                        var maximumInput = liveSection.querySelector('input[name="filter.v.price.lte"]');
                        if (maximumInput) maximumInput.value = maxVal;
                    }
                    getFilterData(rangeBar, sectionId);
                })
                sliderEventListener.on("update", function(values) {
                    var liveSection = getFilterRoot();
                    if (!nativeFilterOwnsRoot(liveSection)) return;
                    var minRange = $(this)[0].options.range.min;
                    var maxRange = $(this)[0].options.range.max;
                    var minVal = parseFloat(values[0]);
                    if (minVal >= minRange) {
                        var minimumInput = liveSection.querySelector('input[name="filter.v.price.gte"]');
                        if (minimumInput) minimumInput.value = minVal;
                    }
                    var maxVal = parseFloat(values[1]);
                    if (maxVal <= maxRange) {
                        var maximumInput = liveSection.querySelector('input[name="filter.v.price.lte"]');
                        if (maximumInput) maximumInput.value = maxVal;
                    }
                })
            }
        })

        var prices = filterForm.querySelectorAll('input[type=number]');
        Array.from(prices).forEach(function(price) {
            bindFilterEventOnce(price, 'price', 'change', () => {
                if (window.innerWidth > 767 && nativeFilterOwnsRoot(getFilterRoot())) {
                    getFilterData(price, sectionId)
                }
            });
        });
        var inputs = filterForm.querySelectorAll('input[type=checkbox],input[type=radio]');
        Array.from(inputs).forEach(function(input) {
            bindFilterEventOnce(input, 'choice', 'click', () => {
                  if (window.innerWidth > 767 && nativeFilterOwnsRoot(getFilterRoot())) {
                    getFilterData(input, sectionId)
                  }
            });
        });
        bindFilterEventOnce(filterForm, 'submit', 'submit', (e) => {
            if (window.innerWidth <= 767 && nativeFilterOwnsRoot(getFilterRoot())) {
                e.preventDefault();
                getFilterData(filterForm, sectionId)
            }
        });

      var removeFilters = sectionParent.querySelectorAll('a.yv-applied-filter-remove');
        Array.from(removeFilters).forEach(function(removeFilter) {
            bindFilterEventOnce(removeFilter, 'remove', 'click', (e) => {
                if (!nativeFilterOwnsRoot(getFilterRoot())) return;
                e.preventDefault();
                var _url = removeFilter.getAttribute('href');
                getFilterData(removeFilter, sectionId, _url);
            });
        });
    }
}

function sortByOptions() {
    var section = document.getElementById('CollectionProductsContainer');
    var sortBy = document.querySelectorAll('[name="sort_by"][data-sort-by]');
    if(nativeFilterOwnsRoot(section)){
        var sectionId = section.dataset.id;
        Array.from(sortBy).forEach(function(sort) {
            bindFilterEventOnce(sort, 'sort-option', 'change', (e) => {
                if (!nativeFilterOwnsRoot(getFilterRoot())) return;
                e.preventDefault();
                Array.from(sortBy).forEach(function(sort) {
                    sort.parentNode.classList.remove('selected');
                })

                sort.parentNode.classList.add('selected');
                var sortMenu = document.getElementById('sort__list');
                if(sortMenu){
                    if (sortMenu.classList.contains('active')) {
                        sortMenu.classList.remove('active');
                        if (window.innerWidth > 767) {
                            DOMAnimations.slideUp(sortMenu);
                        } else {
                            document.querySelector('body').classList.remove('open-filter-sort');
                        }
                    }
                }
                document.querySelector('body').classList.remove('open-filter-sort');
                getFilterData(sort, sectionId);
            });
        });
    }
}
function sortByVisibilityChange(){
    if (!nativeFilterOwnsRoot(getFilterRoot())) return;
     var sortMenu = document.querySelector('.collection-sortby-selected');
    var sortList = document.getElementById('sort__list');
    if (sortMenu && sortList) {
        if (window.innerWidth > 767) {
          if(sortList.classList.contains('active')){
            sortList.style.display = 'block';
          }else{
            sortList.style.display = 'none';
          }
          document.querySelector('body').classList.remove('open-filter-sort');
          
        }else{
          sortList.style.display = 'block';
          if(sortList.classList.contains('active')){
          document.querySelector('body').classList.add('open-filter-sort');
          }else{
          document.querySelector('body').classList.remove('open-filter-sort');
          }
        }
    }
}
function sortBy() {
    if (!nativeFilterOwnsRoot(getFilterRoot())) return;
    var sortMenu = document.querySelector('.collection-sortby-selected');
    if (sortMenu) {          
        bindFilterEventOnce(sortMenu, 'sort-menu', 'click', (e) => {
            if (!nativeFilterOwnsRoot(getFilterRoot())) return;
            e.preventDefault();
            var sortMenu = document.getElementById('sort__list');
            if (!sortMenu) return;
            if (sortMenu.classList.contains('active')) {
                sortMenu.classList.remove('active');
                if (window.innerWidth > 767) {
                    DOMAnimations.slideUp(sortMenu);
                } else {
                    document.querySelector('body').classList.remove('open-filter-sort');
                }
            } else {
                sortMenu.classList.add('active');
                if (window.innerWidth > 767) {
                    DOMAnimations.slideDown(sortMenu);
                } else {
                    document.querySelector('body').classList.add('open-filter-sort');
                }
            }
        });
    }
    var closeSortMenu = document.querySelector('.close-sort');
    if (closeSortMenu) {
        bindFilterEventOnce(closeSortMenu, 'sort-close', 'click', (e) => {
            if (!nativeFilterOwnsRoot(getFilterRoot())) return;
            e.preventDefault();
            var sortMenu = document.getElementById('sort__list');
            if (window.innerWidth < 768) {
                sortMenu.classList.remove('active');
                document.querySelector('body').classList.remove('open-filter-sort');
            }
        });
    }
}

function updateGridView(section) {
    if (section && nativeFilterOwnsRoot(getFilterRoot())) {
        var mainSection = document.getElementById('CollectionProductsContainer');
        if (!mainSection) return;
        var _layout = mainSection.getAttribute('data-view');
        var productItems = section.querySelectorAll('[data-product-grid]');
        var layoutClasses = (layout2 + ' ' + layout3 + ' ' + layout4 + ' ' + layout5).split(' ');
        if (productItems.length > 0) {
            Array.from(productItems).forEach(function(item) {
                layoutClasses.forEach(function(className) {
                    if (className) item.classList.remove(className);
                });
                var selectedLayout = '';
                if (_layout == 'grid-layout-2') {
                    selectedLayout = layout2;
                } else if (_layout == 'grid-layout-3') {
                    selectedLayout = layout3;
                } else if (_layout == 'grid-layout-4') {
                    selectedLayout = layout4;
                } else if (_layout == 'grid-layout-5') {
                    selectedLayout = layout5;
                }
                selectedLayout.split(' ').forEach(function(className) {
                    if (className) item.classList.add(className);
                });
            });
        }
        refreshFilterAOS();
    }
}

function fetchFilterData(url, signal) {
    return fetch(url, signal ? { signal: signal } : {})
        .then(function(response) {
            if (!response || !response.ok) {
                throw new Error('Filter request failed');
            }
            return response.text();
        });
}

function buildFilterUrls(sectionId, searchParameters, remove) {
    var publicUrl;
    if (remove) {
        publicUrl = new URL(remove, window.location.origin);
    } else {
        publicUrl = new URL(window.location.pathname, window.location.origin);
        publicUrl.search = searchParameters ? '?' + searchParameters : '';
    }
    publicUrl.searchParams.delete('section_id');
    var requestUrl = new URL(publicUrl.href);
    requestUrl.searchParams.set('section_id', sectionId);
    return {
        request: requestUrl.pathname + requestUrl.search,
        public: publicUrl.pathname + publicUrl.search + publicUrl.hash
    };
}

function filterUrlKey(url) {
    try {
        var parsedUrl = new URL(url, window.location.origin);
        parsedUrl.hash = '';
        return parsedUrl.pathname + parsedUrl.search;
    } catch (_error) {
        return '';
    }
}

function filterRequestIsCurrent(sequence, controller, root) {
    return Boolean(
        upvFilterLifecycle.filterSequence == sequence &&
        upvFilterLifecycle.filterController == controller &&
        upvFilterLifecycle.filterRequestRoot == root &&
        root == getFilterRoot() &&
        nativeFilterOwnsRoot(root)
    );
}

function finishFilterRequest(sequence, controller, root) {
    if (
        upvFilterLifecycle.filterSequence == sequence &&
        upvFilterLifecycle.filterController == controller
    ) {
        if (root && root.removeAttribute) root.removeAttribute('aria-busy');
        upvFilterLifecycle.filterController = null;
        upvFilterLifecycle.filterRequestRoot = null;
    }
}

function getFilterData(input, sectionId, remove, options) {
    var root = getFilterRoot();
    var filterForm = document.getElementById('FiltersForm');
    if (!nativeFilterOwnsRoot(root) || !filterForm || !sectionId) {
        return Promise.resolve(false);
    }

    options = options || {};
    cancelLoadMoreRequest();
    var previousRequestRoot = upvFilterLifecycle.filterRequestRoot;
    abortFilterController(upvFilterLifecycle.filterController);
    if (previousRequestRoot && previousRequestRoot != root && previousRequestRoot.removeAttribute) {
        previousRequestRoot.removeAttribute('aria-busy');
    }
    upvFilterLifecycle.filterSequence += 1;
    var sequence = upvFilterLifecycle.filterSequence;
    var controller = createFilterAbortController();
    upvFilterLifecycle.filterController = controller;
    upvFilterLifecycle.filterRequestRoot = root;
    root.setAttribute('aria-busy', 'true');
    root.removeAttribute('data-upv-filter-request-error');
    root.removeAttribute('data-upv-filter-history-error');

    var inputId = input && input.getAttribute ? input.getAttribute('id') : null;
    var inputName = input && input.getAttribute ? input.getAttribute('name') : null;

    var settle = function() {
        finishFilterRequest(sequence, controller, root);
    };

    var urls;
    try {
        var searchParameters = '';
        if (!remove) {
            var formData = new FormData(filterForm);
            searchParameters = new URLSearchParams(formData).toString();
        }
        urls = buildFilterUrls(sectionId, searchParameters, remove);
    } catch (_error) {
        root.setAttribute('data-upv-filter-request-error', 'true');
        settle();
        return Promise.resolve(false);
    }

    return Promise.resolve()
        .then(function() {
            return fetchFilterData(urls.request, controller.signal);
        })
        .then(function(responseText) {
            var resultData = new DOMParser().parseFromString(responseText, 'text/html');
            var resultRoot = resultData.getElementById('CollectionProductsContainer');
            if (!resultRoot) throw new Error('Filter response root missing');
            if (
                !resultRoot.dataset.id ||
                String(resultRoot.dataset.id) != String(sectionId) ||
                resultRoot.getAttribute('data-upv-filter-owner') != 'native'
            ) {
                throw new Error('Filter response section mismatch');
            }
            if (!filterRequestIsCurrent(sequence, controller, root)) return false;

            var itemResultCount = resultData.querySelector('.products-count');
            var resultSort = resultData.getElementById('toolbox-sort');
            var resultClear = resultData.getElementById('yv-applied-filter-cross-all');
            updateGridView(resultRoot);
            root.innerHTML = resultRoot.innerHTML;

            var filterHeadingWrapper = document.querySelector('.filter-heading-wrapper');
            var currentClear = document.getElementById('yv-applied-filter-cross-all');
            if (resultClear) {
                if (currentClear && currentClear.parentNode) {
                    currentClear.parentNode.replaceChild(resultClear, currentClear);
                } else if (filterHeadingWrapper) {
                    filterHeadingWrapper.appendChild(resultClear);
                }
            } else if (currentClear && currentClear.parentNode) {
                currentClear.parentNode.removeChild(currentClear);
            }

            var currentResultCount = document.querySelector('.products-count');
            if (itemResultCount && currentResultCount) {
                currentResultCount.innerHTML = itemResultCount.innerHTML;
            }
            var currentSort = document.getElementById('toolbox-sort');
            if (currentSort && resultSort) currentSort.innerHTML = resultSort.innerHTML;

            document.body.classList.remove('open-filter-sort');
            document.body.classList.remove('open-filter-popup');
            filters = document.getElementById('filterSideBar');
            filterContainer = root;

            if (options.history !== false) {
                var currentUrl = window.location.pathname + window.location.search + window.location.hash;
                if (currentUrl != urls.public) {
                    try {
                        var historyApi = window.history || (typeof history != 'undefined' ? history : null);
                        if (!historyApi || typeof historyApi.pushState != 'function') {
                            throw new Error('History API unavailable');
                        }
                        historyApi.pushState({}, null, urls.public);
                    } catch (_error) {
                        root.setAttribute('data-upv-filter-history-error', 'true');
                        if (window.location && typeof window.location.assign == 'function') {
                            try { window.location.assign(urls.public); } catch (_navigationError) {}
                        }
                    }
                }
            }

            try { initializeNativeFilters(); } catch (_error) {
                root.setAttribute('data-upv-filter-init-error', 'true');
            }

            if (options.focus !== false && inputId) {
                try {
                    var updateInput = document.getElementById(inputId);
                    if (updateInput && typeof updateInput.focus == 'function') {
                        updateInput.focus();
                        var moreOption = updateInput.closest('.more-options');
                        if (moreOption) {
                            moreOption.style.display = 'block';
                            var filterContent = updateInput.closest('.yv-filter-content');
                            var moreOptionText = filterContent && filterContent.querySelector('.filters-expand');
                            if (moreOptionText) {
                                moreOptionText.classList.add('active');
                                var moreOptionLabel = moreOptionText.querySelector('span');
                                if (moreOptionLabel) moreOptionLabel.textContent = showLessText;
                            }
                        }
                    }
                } catch (_error) {}
            }

            refreshFilterAOS();
            runOptionalFilterHydrator('productVariants');
            runOptionalFilterHydrator('gridPickUpAvailability');
            runOptionalFilterHydrator('productHoverSlider');

            if (options.scroll !== false && inputName != 'sort_by') {
                try {
                    var collectionContainer = root.closest('.yv-collection-container');
                    if (collectionContainer && typeof collectionContainer.scrollIntoView == 'function') {
                        collectionContainer.scrollIntoView({ block: 'start', behavior: 'smooth' });
                    }
                } catch (_error) {}
            }
            return true;
        })
        .catch(function(error) {
            if (!isFilterAbortError(error) && filterRequestIsCurrent(sequence, controller, root)) {
                root.setAttribute('data-upv-filter-request-error', 'true');
            }
            return false;
        })
        .then(function(result) {
            settle();
            return result;
        }, function(error) {
            settle();
            return false;
        });
}



function loadMoreRequestIsCurrent(sequence, controller, root, sentinel) {
    return Boolean(
        upvFilterLifecycle.loadMoreSequence == sequence &&
        upvFilterLifecycle.loadMoreController == controller &&
        upvFilterLifecycle.loadMoreRoot == root &&
        upvFilterLifecycle.loadMoreSentinel == sentinel &&
        root == getFilterRoot() &&
        nativeFilterOwnsRoot(root) &&
        document.documentElement.contains(sentinel)
    );
}

function finishLoadMoreRequest(sequence, controller, sentinel) {
    if (
        upvFilterLifecycle.loadMoreSequence == sequence &&
        upvFilterLifecycle.loadMoreController == controller
    ) {
        var loader = sentinel && sentinel.querySelector ? sentinel.querySelector('.load') : null;
        if (loader) loader.classList.add('hidden');
        upvFilterLifecycle.loadMoreController = null;
        upvFilterLifecycle.loadMoreRoot = null;
        upvFilterLifecycle.loadMoreSentinel = null;
    }
}

function ScrollExecute() {
    var root = getFilterRoot();
    if (
        !nativeFilterOwnsRoot(root) ||
        upvFilterLifecycle.filterController ||
        upvFilterLifecycle.loadMoreController
    ) {
        return Promise.resolve(false);
    }
    var moreButtons = root.querySelectorAll('#more');
    var sentinel = moreButtons.length ? moreButtons[moreButtons.length - 1] : null;
    var link = sentinel && sentinel.querySelector('a[href]');
    if (!sentinel || !link) return Promise.resolve(false);
    var bounds = sentinel.getBoundingClientRect();
    if (bounds.top > window.innerHeight + 200 || bounds.bottom < -200) {
        return Promise.resolve(false);
    }

    var nextUrl = link.getAttribute('href');
    if (!nextUrl) return Promise.resolve(false);
    upvFilterLifecycle.loadMoreSequence += 1;
    var sequence = upvFilterLifecycle.loadMoreSequence;
    var controller = createFilterAbortController();
    upvFilterLifecycle.loadMoreController = controller;
    upvFilterLifecycle.loadMoreRoot = root;
    upvFilterLifecycle.loadMoreSentinel = sentinel;
    var loader = sentinel.querySelector('.load');
    if (loader) loader.classList.remove('hidden');
    sentinel.removeAttribute('data-upv-load-more-error');

    var settle = function() {
        finishLoadMoreRequest(sequence, controller, sentinel);
    };

    return Promise.resolve()
        .then(function() {
            return fetchFilterData(nextUrl, controller.signal);
        })
        .then(function(responseText) {
            var resultData = new DOMParser().parseFromString(responseText, 'text/html');
            var resultRoot = resultData.getElementById('CollectionProductsContainer');
            var resultProducts = resultRoot && resultRoot.querySelector('[data-collection-products]');
            var currentProducts = root.querySelector('[data-collection-products]');
            if (!resultRoot || !resultProducts || !currentProducts) {
                throw new Error('Load-more response is incomplete');
            }
            if (
                !resultRoot.dataset.id ||
                !root.dataset.id ||
                String(resultRoot.dataset.id) != String(root.dataset.id) ||
                resultRoot.getAttribute('data-upv-filter-owner') != 'native'
            ) {
                throw new Error('Load-more response section mismatch');
            }
            if (!loadMoreRequestIsCurrent(sequence, controller, root, sentinel)) return false;

            updateGridView(resultRoot);
            var nextSentinelCandidate = resultRoot.querySelector('#more');
            if (nextSentinelCandidate && nextSentinelCandidate.parentNode) {
                nextSentinelCandidate.parentNode.removeChild(nextSentinelCandidate);
            }
            var nextLink = nextSentinelCandidate && nextSentinelCandidate.querySelector('a[href]');
            var nextHref = nextLink && nextLink.getAttribute('href');
            var nextSentinel = nextHref && filterUrlKey(nextHref) != filterUrlKey(nextUrl) ?
                nextSentinelCandidate : null;
            var fragment = document.createDocumentFragment();
            while (resultProducts.firstChild) fragment.appendChild(resultProducts.firstChild);
            currentProducts.appendChild(fragment);
            if (sentinel.parentNode) {
                if (nextSentinel) {
                    sentinel.parentNode.replaceChild(nextSentinel, sentinel);
                } else {
                    sentinel.parentNode.removeChild(sentinel);
                }
            }

            runOptionalFilterHydrator('productVariants');
            runOptionalFilterHydrator('gridPickUpAvailability');
            runOptionalFilterHydrator('productHoverSlider');
            refreshFilterAOS();
            return true;
        })
        .catch(function(error) {
            if (!isFilterAbortError(error) && loadMoreRequestIsCurrent(sequence, controller, root, sentinel)) {
                sentinel.setAttribute('data-upv-load-more-error', 'true');
            }
            return false;
        })
        .then(function(result) {
            settle();
            if (result) scheduleFilterScrollWork();
            return result;
        }, function(error) {
            settle();
            return false;
        });
}

function handleNativeFilterPopstate() {
    var root = getFilterRoot();
    if (
        root &&
        (
            root.getAttribute('data-upv-filter-owner') == 'globo' ||
            globoFilterIsRendered(root)
        )
    ) {
        try {
            window.location.reload();
        } catch (_error) {
            try { window.location.assign(window.location.href); } catch (_navigationError) {}
        }
        return;
    }
    var form = document.getElementById('FiltersForm');
    if (!nativeFilterOwnsRoot(root) || !form) return;
    var expectedUrl = window.location.href;
    getFilterData(form, root.dataset.id, expectedUrl, {
        history: false,
        focus: false,
        scroll: false
    }).then(function(success) {
        if (
            !success &&
            nativeFilterOwnsRoot(getFilterRoot()) &&
            !upvFilterLifecycle.filterController &&
            window.location &&
            window.location.href == expectedUrl
        ) {
            try { window.location.assign(window.location.href); } catch (_error) {}
        }
    });
}

window.addEventListener('popstate', handleNativeFilterPopstate);
window.addEventListener('pagehide', cancelAllFilterWork);
document.addEventListener('shopify:section:unload', function(event) {
    var root = upvFilterLifecycle.activeRoot;
    var target = event && event.target;
    if (root && target && (target == root || (typeof target.contains == 'function' && target.contains(root)))) {
        cancelAllFilterWork();
        upvFilterLifecycle.activeRoot = null;
    }
});
